import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Select,
  Space,
  Spin,
  InputNumber,
  message,
  Flex, Upload,
} from "antd";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import styles from "./index.module.scss";
import jwtAxios from "../../../../auth/jwt-api";
import { useUrlSearchParams } from "use-url-search-params";
import TextArea from "antd/es/input/TextArea";
import ReactInputMask from "react-input-mask";
import { ExclamationCircleFilled, UploadOutlined } from "@ant-design/icons";
import translate from "../../../../i18n/translate";
import {useAuthDatas} from "../../../../auth/JWTAuthProvider";
const { confirm } = Modal;

export default function PaymentModel({
  refetchInfo,
  order,
  searchParams,
  setSearchParams,
}) {
  const isOpen = searchParams.paymentModel;
  const [loading, setLoading] = useState(false);
  const [currency, setCurrency] = useState("uzs");
  const [checkFileId, setCheckFileId] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [form] = Form.useForm();
  const { user } = useAuthDatas();

  const handleUpload = async ({ file, onSuccess, onError }) => {
    const formData = new FormData();
    formData.append("file", file);
    try {
      const res = await jwtAxios.post("/media/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      console.log(res)
      setCheckFileId(res.data?.data?.media?.id);
      onSuccess(res.data);
    } catch (err) {
      onError(err);
      message.error("Произошла ошибка");
    }
  };

  const onFinish = async (data) => {

    setLoading(true);
    data.currency = currency;
    data.orderId = order.id;
    if (data.date) {
      data.date = data.date.format("YYYY-MM-DD");
    }
    if (checkFileId) data.checkFileId = checkFileId;
    try {
      await jwtAxios.post(`/payment`, data);
      refetchInfo();
      setSearchParams({
        ...searchParams,
        paymentModel: undefined,
      });
      form.resetFields();
      setCheckFileId(null);
      setFileList([]);
      message.success("Успешно изменено");
    } catch (error) {
      message.error(error.response?.data?.error || "Произошла ошибка");
      console.log(error);
    }
    setLoading(false);
    //   },
    // });
  };

  const onCancel = () => {
    setSearchParams({
      ...searchParams,
      paymentModel: undefined,
    });
  };

  return (
    <Modal
      centered
      open={!!isOpen}
      onCancel={onCancel}

      title={translate("payment.add")}
      footer={""}
    >
      <br />
      <Form
        onFinish={onFinish}
        layout="vertical"
        initialValues={{
          type: "cash",

        }}
        form={form}
      >
        <Form.Item
          label={translate("form.label.payment_amount")}
          name="amount"
          rules={[
            {
              required: true,
              message: translate("form.error.amount_required"),
            },
          ]}
        >
          <InputNumber
            style={{ display: "block", width: "100%" }}
            placeholder={translate("payment.amount_placeholder")}
            addonAfter={translate("misc.currency")}
            formatter={(value) =>
                value
                    ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                    : ""
            }
            parser={(value) => value.replace(/\s/g, "")}
          />
        </Form.Item>
        <Form.Item label={translate("form.label.payment_type")} name="type">
          <Select
            options={[

              {
                label: translate("payment.cash"),
                value: "cash",
              },
              {
                label: translate("payment.installment"),
                value: "installment",
              },
              {
                label: translate("payment.booking"),
                value: "booking",
              },
            ]}
          />
        </Form.Item>

        <Form.Item
          label="Дата оплаты"
          name="date"
          rules={[
            {
              required: true,
              message: "Выберите дату оплаты",
            },
          ]}
        >
          <DatePicker format="DD.MM.YYYY" style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item>
          <Flex align="center" justify="space-between" gap={10} wrap="nowrap">
            <Upload
              customRequest={handleUpload}
              fileList={fileList}
              onChange={({ fileList: newList }) => setFileList(newList.slice(-1))}
              onRemove={() => setCheckFileId(null)}
              maxCount={1}
              accept="image/*"
            >
              <Button icon={<UploadOutlined />}>
                {translate("payment.upload_check")}
              </Button>
            </Upload>
            <Flex gap={10}>
              <Button
                type="primary"
                ghost
                htmlType="button"
                loading={loading}
                onClick={onCancel}
              >
                {translate("button.cancel")}
              </Button>
              <Button type="primary" htmlType="submit" loading={loading}>
                {translate("button.submit")}
              </Button>
            </Flex>
          </Flex>
        </Form.Item>
      </Form>
    </Modal>
  );
}
